// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.selected[data-v-fae5bece] {\r\n    font-weight: bold;\n}\n.yellow[data-v-fae5bece] {\r\n    color: #ffc72c;\n}\n.red[data-v-fae5bece] {\r\n    color: #fe6064;\n}\n.blue[data-v-fae5bece] {\r\n    color: #9acaeb;\n}\r\n", ""]);
// Exports
module.exports = exports;
